import { render, staticRenderFns } from "./Browser.vue?vue&type=template&id=4b10e459&scoped=true"
import script from "./Browser.vue?vue&type=script&lang=js"
export * from "./Browser.vue?vue&type=script&lang=js"
import style0 from "./Browser.vue?vue&type=style&index=0&id=4b10e459&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_d0d1c26b22fe14fd22da96c4620a1900/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b10e459",
  null
  
)

export default component.exports